import { Component } from '@angular/core';

@Component({
  selector: 'anon-headline',
  templateUrl: './headline.component.html',
  styleUrls: ['./headline.component.scss']
})
export class HeadlineComponent {}
